import { emailPattern } from '@auth/login/data/login.model';
import { TranslateService } from '@ngx-translate/core';
import { SearchInputComponent } from '@widgets/filter/specific/components/search-input/search-input.component';
import { SingleDateTimeSelectComponent } from '@widgets/filter/specific/components/single-date-time-select/single-date-time-select.component';
import { SingleselectComponent } from '@widgets/filter/specific/components/singleselect/singleselect.component';
import { ETimePeriod } from '@widgets/filter/specific/data/filter-container.model';
import { FilterContainerConfiguration } from '@widgets/filter/specific/filter-container.component';
import { FilterBackendService } from '@widgets/filter/specific/services/filter-backend.service';
import {
  ComponentData,
  SpecificFilterConfig,
} from '@widgets/filter/specific/services/filter-frontend.model';
import { FilterUtilService } from '@widgets/filter/specific/services/filter-util.service';
import moment from 'moment';
import { Observable, map, of } from 'rxjs';
import { ReceiptType } from '../data/receipts.model';
import { ReceiptsService } from '../services/receipts.service';

export class ReceiptsTableFilterConfig {
  public static getFilterConfig(
    translate: TranslateService,
    receiptsService: ReceiptsService,
    filterBackendService: FilterBackendService,
    filterUtilService: FilterUtilService,
    type: ReceiptType
  ): FilterContainerConfiguration[] {
    return [
      {
        type: SingleDateTimeSelectComponent,
        title: translate.instant('TERMINAL_MANAGEMENT.SESSION_START_FILTER'),
        mandatory: true,
        data$: this.getPeriodFilterData$(filterBackendService),
      },
      ...(type === ReceiptType.PAYMENT_TERMINAL
        ? [
            {
              type: SearchInputComponent,
              title: translate.instant('TERMINAL_MANAGEMENT.TERMINAL_ID_SHORT'),
              mandatory: true,
              data$: this.getSearchInputComponentData$({
                serverKeys: ['terminalId'],
              }),
            },
          ]
        : []),
      {
        type: SearchInputComponent,
        title: translate.instant('TERMINAL_MANAGEMENT.TRANSACTION_ID'),
        mandatory: type === ReceiptType.DIRECT_PAYMENT,
        data$: this.getSearchInputComponentData$({
          serverKeys: ['transactionId'],
        }),
      },
      {
        type: SearchInputComponent,
        title: translate.instant('TERMINAL_MANAGEMENT.LAST_4_DIGITS'),
        data$: this.getSearchInputComponentData$({
          serverKeys: ['cardNumberSuffix'],
        }),
      },
      {
        type: SingleselectComponent,
        title: translate.instant('TERMINAL_MANAGEMENT.CARD_TYPE'),
        data$: receiptsService
          .getCardTypes()
          .pipe(
            map(cardTypes =>
              filterUtilService.buildComponentData(
                SingleselectComponent,
                null,
                ['cardType'],
                cardTypes
              )
            )
          ),
        service: 'receiptsService',
        func: 'getCardTypes',
      },
      {
        type: SearchInputComponent,
        title: translate.instant('CHARGING_STATION.CHARGE_PORT_ID'),
        mandatory: true,
        data$: this.getSearchInputComponentData$({
          serverKeys: ['chargePortName'],
        }),
      },
      ...(type === ReceiptType.PAYMENT_TERMINAL
        ? []
        : [
            {
              type: SearchInputComponent,
              title: translate.instant('GLOBAL.EMAIL_SHORT'),
              data$: this.getSearchInputComponentData$(
                {
                  serverKeys: ['email'],
                },
                emailPattern
              ),
            },
          ]),
    ];
  }

  private static getSearchInputComponentData$(
    config: SpecificFilterConfig,
    inputRegex?: string
  ): Observable<ComponentData> {
    return of({
      items: [
        {
          id: '',
          name: '',
          chipValue: '',
          selected: false,
          value: {
            [config.serverKeys[0]]: '',
          },
          placeholder: null,
          inputRegex: inputRegex,
          maxInputLength: 10000,
        },
      ],
    });
  }

  static getPeriodFilterData$(
    filterBackendService: FilterBackendService
  ): Observable<ComponentData> {
    return filterBackendService.getPeriodsOfTimeRecords$(
      {
        serverKeys: ['sessionStartFrom', 'sessionStartTo'],
      },
      [
        ETimePeriod.TODAY,
        ETimePeriod.LAST_7_DAYS,
        ETimePeriod.CURRENT_MONTH,
        ETimePeriod.LAST_MONTH,
        ETimePeriod.INDIVIDUAL_TIME_PERIOD,
      ],
      {
        maxDate: moment().endOf('day').toISOString(),
      }
    );
  }
}
